export enum EOfferTypes {
  /** Коммерческая **/
  Commercial = 'commercial',
  /** Жилая **/
  Flat = 'flat',
  /** Загородная **/
  Suburban = 'suburban',
}
